<div class="bisual-table">
  <form class="card paginator" [formGroup]="filterForm">
    <button mat-flat-button color="accent" type="button" (click)="openCreateDialog()">Nueva formación</button>

    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="pageIndex"
      (page)="changePage($event)"
      style="margin-right: auto"
    ></mat-paginator>

    <mat-form-field>
      <input matInput type="text" formControlName="search" placeholder="Buscar..." />
      <button matSuffix mat-icon-button aria-label="Buscar" type="button">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </form>

  <div class="bisual-table-container">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="duration_in_hours">
        <th mat-header-cell *matHeaderCellDef>Duración (h)</th>
        <td mat-cell *matCellDef="let element">{{ element.duration_in_hours ?? '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="skills">
        <th mat-header-cell *matHeaderCellDef>Skills</th>
        <td mat-cell *matCellDef="let element">
          <span [matTooltip]="element.skills_label.length > 50 ? element.skills_label : null">
            {{ element.skills_label }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="actions-cell">
          <div class="table-actions">
            <button mat-icon-button type="button" matTooltip="Editar" (click)="openEditDialog(element)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button type="button" matTooltip="Eliminar" (click)="deleteLearningResource(element)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
